import React, { useState } from "react";
export default function Contact({ language }) {

    return (
        <section className="w-full bg-[#fffaf0] py-16 px-6 md:px-12">
            <h2 className="text-3xl font-bold mb-6 text-center">
                {language === "JP" ? "お問い合わせ" : language === "ZH" ? "联系" : "Contact"}
            </h2>
                        <div className="w-full ">
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScvBxlAEArgk5iCuHzNRl2Xs6XCgy7imWPDGjggtVdcvu7e0g/viewform?embedded=true" width="100%" height="700" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                        </div>
        </section>
    );
}
